import { MagnoliaApp } from '../components/pages/MagnoliaApp'
export default MagnoliaApp
